import React, { useState, useEffect } from 'react';
import { uploadFile } from '../../../globalFunctions/GlobalFunctions';
import { message, Button, Spin, Space, Table, Form, Modal, Popconfirm, Tooltip } from 'antd';
import { COOKIE, getCookie } from '../../../services/cookie';
import constants from '../../../constants/constants';
import { DeleteOutlined } from '@ant-design/icons';
import { fetchApi } from '../../../services/api';
import { useHistory } from "react-router";

const VideoList = () => {
	const [form] = Form.useForm();
	const [fileList, setFileList] = useState([]);
	const [loader, setLoader] = useState(false);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const tailLayout = { wrapperCol: { span: 24 } };
	const [tableData, setTableData] = useState([]);
	let logintype = getCookie(COOKIE.LoginType);
	let clientId = getCookie(COOKIE.ClientId);
	const history = useHistory();
	useEffect(() => {
		getEmailId();
	}, []);

	const getVideoList = async () => {
		setLoader(true);
		await fetchApi(`/get-resource-list`, "get").then((res) => {
			if (res?.code === 200) {
				setLoader(false);
				setTableData(res.data);
			} else {
				setLoader(false);
				setTableData([]);
			}
		});
	};

	const getEmailId = () => {
		fetchApi(`/client-profile/${clientId}`, "get").then((res) => {
			if (res && res.data && res.code === 200) {
				let emailId = res?.data?.email;
				if (logintype === "1" && emailId === "demoa5267@gmail.com" || logintype == "1" && emailId === "admin@mailinator.com" || logintype === "1" && emailId === "roy@mailinator.com" || logintype === "1" && emailId === "Roy@mailinator.com") {
					getVideoList();
				} else {
					history.push("/");
					message.error("Invalid User");
				}
			}
		});
	};

	const handleFileChange = ({ fileList }) => {
		if (!fileList.length) return;
		const file = fileList[0];
		if (beforeUploadVideo(file, false)) {
			setFileList(fileList);
		}
	};

	function beforeUploadVideo(file, errorMessage = true) {
		const isMp4 = file?.name?.endsWith(".mp4");
		if (!isMp4) {
			if (errorMessage) {
				message.error("You can only upload MP4 files!");
			}
			return false;
		}
		// Check for file size (should be less than 100MB)
		const fileSizeMB = file.size / (1024 * 1024); // Convert size to MB
		const isLt100M = fileSizeMB < 100;
		if (!isLt100M) {
			if (errorMessage) {
				message.error("Max file size accepted is 100MB!");
			}
			return false;
		}
		return true
	};

	const handleRemove = (file) => {
		// remove the file from the fileList
		const index = fileList.indexOf(file);
		const newFileList = fileList.slice();
		newFileList.splice(index, 1);
		setFileList(newFileList);
	};

	const uploadVideo = async () => {
		if (!fileList.length) {
			message.error("Please select a video to upload");
			return;
		}
		setLoader(true);
		try {
			const formData = new FormData();
			fileList.forEach((file) => {
				formData.append('files[]', file.originFileObj);
			});
			const response = await fetch(`${constants.ApiUrl}/upload-video`, {
				method: 'POST',
				body: formData,
				headers: { Authorization: `Bearer ${getCookie(COOKIE.Token)}` },
			});
			const data = await response.json();
			if (data.code === 200) {
				setLoader(false);
				message.success(data.message);
				getVideoList();
				setIsModalOpen(false);
				setFileList([]);
			} else {
				setLoader(false);
				message.error(data.message);
			}
		} catch (error) {
			setLoader(false);
			message.error(error.message);
		}
	};

	const columns = [
		{
			title: '#',
			align: "center",
			key: 'serial_no',
			width: "5%",
			render: (_serial_no, _index, i) => {
				return <span className="text-right w-6 block m-auto">{i + 1}</span>;
			}
		},
		{
			title: 'Action',
			align: "center",
			key: 'preview',
			width: "10%",
			render: (value) => {
				return <Space>
					{/* <Tooltip title={constants.Play}>
						<Button type='text' icon={<PlayCircleOutlined />}></Button>
					</Tooltip> */}
					<Tooltip title={constants.Delete}>
						<Popconfirm title="Sure to Delete?" onConfirm={() => handleDelete(value)}>
							<Button style={{ color: "red" }} type='text' icon={<DeleteOutlined />} />
						</Popconfirm>
					</Tooltip>
				</Space>
			}
		},
		{
			title: 'Name',
			align: "center",
			dataIndex: 'folder_name',
			key: 'folder_name',
			render: (video_name) => {
				return <span>{video_name}</span>;
			}
		},
		{
			title: 'Section',
			align: "center",
			dataIndex: 'section_id',
			key: 'section_id',
			render: (section) => {
				return <span className="text-right w-6 block m-auto">{section}</span>;
			}
		},
		{
			title: 'Part',
			align: "center",
			dataIndex: 'part_id',
			key: 'part_id',
			render: (part) => {
				return <span className="text-right w-6 block m-auto">{part}</span>;
			}
		},
	];

	const handleOk = () => {
		setIsModalOpen(false);
	};
	const handleCancel = () => {
		setIsModalOpen(false);
	};

	const addVideo = () => {
		setIsModalOpen(!isModalOpen);
	};

	const handleDelete = (values) => {
		setLoader(true);
		let url, payload;
		if (values?.is_video) {
			url = '/delete-video';
			payload = {
				filename: values?.folder_name
			}
		} else {
			url = '/delete-folder';
			payload = {
				foldername: values?.folder_name
			}
		}
		fetchApi(url, "post", payload).then((res) => {
			if (res?.code === 200) {
				setLoader(false);
				message.success(res?.message);
				getVideoList()
			} else {
				setLoader(false);
				message.error(res?.message);
			}
		});
	};

	return (
		<div>
			<div className='text-center bg-amber-300 text-lg font-semibold p-3'>{constants.Subtitle}
				<span className="py-0.5 px-3 ml-3 text-sm bg-white rounded-xl">{constants.WbVideoList}</span>
			</div>
			<div className='container mx-auto'>
				<Spin spinning={loader} size="large">
					<Button className='bg-sky-800 text-white uppercase my-2.5' onClick={addVideo}>{constants.UploadVideo}</Button>
					<Table
						pagination={false}
						dataSource={tableData}
						rowKey={(record, index) => index}
						columns={columns}
						bordered
						locale={{ emptyText: 'No Records Found' }}
						className='mt-2'
						size="small"
					/>
				</Spin>
			</div>
			<Modal
				title={<div className="text-center">{constants.UploadVideo}</div>}
				open={isModalOpen}
				onOk={handleOk}
				onCancel={handleCancel}
				footer={null}
				centered
				style={{ top: 20 }}
				width={700}
				className="client-details"
			>
				<Form
					form={form}
					labelWrap
					onFinish={uploadVideo}
					layout="vertical"
				>
					{uploadFile(fileList, handleFileChange, handleRemove, beforeUploadVideo, "upload-video")}
					<Form.Item {...tailLayout}>
						<Space className="float-right">
							<Button
								size="middle"
								onClick={handleCancel}
							>
								{constants.CancelBTN}
							</Button>
							<Tooltip title={fileList.length === 0 ? "Please select a video first" : ""}>
								<Button
									size="middle"
									className='bg-sky-800 text-white'
									htmlType="submit"
									loading={loader}
									disabled={fileList.length === 0}
								>
									Upload
								</Button>
							</Tooltip>
						</Space>
					</Form.Item>
				</Form>
			</Modal>
		</div>
	)
}

export default VideoList;